import { TKV2_ORDER_API, ToolkitOrder } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { fetchGetTkv2OrderAPI } from '../../hooks/api/toolkitComponents.js';
import { useToolkitContext } from '../../hooks/api/toolkitContext.js';

export function useTkv2Order(
  params: { pathParams: { orderID: string } },
  opts?: UseQueryOptions<ToolkitOrder>,
): UseQueryResult<ToolkitOrder> {
  const { fetcherOptions } = useToolkitContext();
  return useQuery<ToolkitOrder>(
    ['order', params.pathParams.orderID],
    async () => {
      const res = await fetchGetTkv2OrderAPI({ ...fetcherOptions, ...params });
      return TKV2_ORDER_API.GET.RESPONSE.parse(res);
    },
    opts,
  );
}
